export default __webpack_public_path__ + "static/media/oops.7ece88f9.svg";